import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

export const addInterceptor = (url: string) => {
  axios.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      config.url = url + config.url;
      config.headers.common.Accept = 'application/json';
      config.headers.post = 'application/json';
      // config.headers.common.Authorization = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7ImlkIjoxLCJ1c2VybmFtZSI6ImFkbWluIn0sImlhdCI6MTU0MzM0OTA1MX0.QXiKrjhIsM0nJQNuuGJhepXFwBPqWAG2BeKX7YoB6ao`;
      return config;
    },
    (error: AxiosError) => {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response: AxiosResponse) => {
      // Do something with response data
      console.log(response.data);
      return response;
    },
    (error: AxiosError) => {
      // Do something with response error
      // if (error.response && error.response.status === 401) {
      //   history.push('/login');
      // }
      if (error.response) {
        console.error(error.response.data.error);
        if (error.response.data.error) {
          return Promise.reject(error.response.data.error);
        } else if (error.response.data) {
          return Promise.reject(new Error(error.response.statusText));
        } else {
          return Promise.reject(new Error('Undefined Error occured'));
        }
      } else {
        console.error(error);
        if (error.message === 'Network Error') {
          error.message = 'Verbindung zum Server fehlgeschlagen';
        }
        return Promise.reject(error);
      }
    }
  );
};

let myInterceptor: any;

export const setAxiosToken = (token: string) => {
  if (myInterceptor) {
    removeAxiosToken();
  }
  console.log('SETTING AXIOS TOKEN', token);
  myInterceptor = axios.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      config.headers.common.Authorization = 'Bearer ' + token;
      return config;
    },
    (error: AxiosError) => {
      return Promise.reject(error);
    }
  );
};

export const removeAxiosToken = () => {
  axios.interceptors.request.eject(myInterceptor);
};



// WEBPACK FOOTER //
// ./src/utils/axiosHelper.ts